import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/skeletons/GeneralSkeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GameContainer"] */ "/app/src/modules/game/GameContainer/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/localization/hooks/useLanguageChange.ts");
